import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { fundraisingService } from '../../services/fundraisingService';

export const useGetFundraisingStatus = () => {
  return useQuery({
    staleTime: 1000 * 60,
    refetchOnWindowFocus: true,
    queryKey: [QUERY_KEYS.fundraising.status],
    queryFn: () =>
      fundraisingService.status().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return null;
      }),
  });
};
